import { apiClient } from '@/shared/lib/axios';
import { useQuery } from '@tanstack/react-query';

export type HealthCenterRegistTypeOption = { id: number; name: string };

type Response = {
  data: HealthCenterRegistTypeOption[];
};

export const getHealthCenterRegistTypes = async (
  siteType: string | null
): Promise<HealthCenterRegistTypeOption[]> => {
  const response = await apiClient.get<Response>(
    `/admin/${siteType}/master-data/health-center-regist-types`
  );
  return response.data?.data ?? [];
};

export const useHealthCenterRegistTypes = (siteType: string | null) => {
  return useQuery({
    queryKey: ['admin', 'health-center-regist-types', siteType],
    queryFn: () => getHealthCenterRegistTypes(siteType),
    enabled: !!siteType,
  });
};
